import React from "react";
export const SystemContext = React.createContext(
    {
      systemContext: {
        color: "blue",
      }
    }
  );
  